import { render, staticRenderFns } from "./userCreate.vue?vue&type=template&id=24b27295"
import script from "./userCreate.vue?vue&type=script&lang=js"
export * from "./userCreate.vue?vue&type=script&lang=js"
import style0 from "./userCreate.vue?vue&type=style&index=0&id=24b27295&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports